import { t } from '../i18n/index.ts';

/**
 * As siglas das linguagens, nas cores públicas de cada uma. Fullstack mostra
 * as três tecnologias que a trilha junta; as outras mostram uma. Ficam
 * escondidas dos leitores de ecrã porque o nome da trilha vem logo a seguir
 * por extenso. Uma trilha desconhecida não mostra nada nem parte o cartão.
 *
 * Partilhada pelo catálogo e pela página do curso (ADR 0027); os estilos
 * vivem em `catalogo.css`, que os dois ecrãs importam.
 */
export function SiglaDaLinguagem({ trilha }: { trilha: string }) {
  const linguagens =
    trilha === 'fullstack'
      ? (['html', 'css', 'javascript'] as const)
      : trilha === 'javascript' || trilha === 'python' || trilha === 'sql'
        ? ([trilha] as const)
        : [];

  if (linguagens.length === 0) return null;

  return (
    <span className="siglas" aria-hidden="true">
      {linguagens.map((linguagem) => (
        <span key={linguagem} className={`sigla sigla--${linguagem}`}>
          {t(`linguagem.sigla.${linguagem}`)}
        </span>
      ))}
    </span>
  );
}
